import { render, staticRenderFns } from "./FeesFilters.vue?vue&type=template&id=18ba7172"
import script from "./FeesFilters.vue?vue&type=script&lang=js"
export * from "./FeesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports